require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./tooltip"), require("./tags"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./flexlayout", "./truncatedtext", "./tooltip", "./tags"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./flexlayout"), require("./truncatedtext"), require("./tooltip"), require("./tags")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./flexlayout"], root["./truncatedtext"], root["./tooltip"], root["./tags"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__52__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[64],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__21__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/overflow-menu--horizontal_32");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 52:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__52__;

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(530);


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Tile = _interopRequireDefault(__webpack_require__(531));

exports["default"] = _Tile["default"];
exports.Tile = _Tile["default"];

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _svgicon = _interopRequireDefault(__webpack_require__(13));

var _tags = _interopRequireDefault(__webpack_require__(52));

var _truncatedtext = _interopRequireDefault(__webpack_require__(17));

var _flexlayout = _interopRequireWildcard(__webpack_require__(16));

var _tooltip = _interopRequireDefault(__webpack_require__(21));

var _overflowMenuHorizontal_ = _interopRequireDefault(__webpack_require__(41));

var _folder_ = _interopRequireDefault(__webpack_require__(89));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

var _Tile = _interopRequireDefault(__webpack_require__(532));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize;

var tileClassName = _Tile["default"].tileClassName.replace(/"/g, '');

var Tile = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Tile, _Component);

  function Tile() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onContextMenu", function (e) {
      var onMenu = _this.props.onMenu;
      onMenu && onMenu(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._buttonNode = node;
    });
    return _this;
  }

  var _proto = Tile.prototype;

  _proto._menuRenderer = function _menuRenderer() {
    var _this$props = this.props,
        size = _this$props.size,
        ellipsisIcon = _this$props.ellipsisIcon;

    if (size === 'small') {
      return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        className: tileClassName + "__footer__title",
        orient: "bottom",
        title: this.props.ellipsisTooltipLabel,
        delay: true
      }, ellipsisIcon || /*#__PURE__*/_react["default"].createElement(_button["default"], {
        className: tileClassName + "__footer__icon",
        ref: this._ref,
        onClick: this._onContextMenu,
        variant: "inline",
        iconSize: "normal",
        icon: _overflowMenuHorizontal_["default"].id
      }));
    }

    return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      className: tileClassName + "__header__title",
      orient: "bottom",
      title: this.props.ellipsisTooltipLabel,
      delay: true
    }, ellipsisIcon || /*#__PURE__*/_react["default"].createElement(_button["default"], {
      className: tileClassName + "__header__icon",
      ref: this._ref,
      onClick: this._onContextMenu,
      variant: "inline",
      iconSize: "small",
      icon: _overflowMenuHorizontal_["default"].id
    }));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        container = _this$props2.container,
        content = _this$props2.content,
        className = _this$props2.className,
        selected = _this$props2.selected,
        onMenu = _this$props2.onMenu,
        ellipsisIcon = _this$props2.ellipsisIcon,
        size = _this$props2.size,
        textDir = _this$props2.textDir,
        dateLabel = _this$props2.dateLabel,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["container", "content", "className", "selected", "onMenu", "ellipsisIcon", "size", "textDir", "dateLabel"]);
    var classNames = (0, _utils.classnames)(tileClassName, size, {
      selected: selected,
      container: container
    });

    if (container) {
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], (0, _extends2["default"])({
        direction: "row",
        alignItems: "center"
      }, sanitize(others, Tile), {
        tabIndex: "0",
        className: classNames + " " + className
      }), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        className: tileClassName + "__left"
      }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        className: tileClassName + "__left__icon",
        iconId: content.iconId || _folder_["default"].id
      })), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        grow: true,
        shrink: true
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
        direction: "column",
        justifyContent: "center",
        className: tileClassName + "__middle"
      }, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
        className: tileClassName + "__middle__label",
        width: "100%",
        value: content.label,
        textDir: textDir
      })), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: tileClassName + "__middle__date"
      }, content.date)))), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        className: tileClassName + "__right"
      }, (onMenu || ellipsisIcon) && this._menuRenderer())));
    }

    if (size === 'large') {
      var presetColors = ['red', 'magenta', 'purple', 'blue', 'cyan', 'teal', 'green', 'gray', 'coolgray', 'warmgray'];
      var tagColor = presetColors.indexOf(content.color) !== -1 ? content.color : 'coolgray';
      return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], (0, _extends2["default"])({
        direction: "column"
      }, sanitize(others, Tile), {
        tabIndex: "0",
        onContextMenu: onMenu ? this._onContextMenu : null,
        className: classNames + " " + className
      }), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
        alignItems: "center",
        justifyContent: "space-between",
        className: tileClassName + "__header"
      }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        className: tileClassName + "__icon__title",
        orient: "top",
        title: content.type,
        delay: true
      }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
        className: tileClassName + "__header__type",
        iconId: content.iconId,
        title: content.type,
        size: "large"
      })), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, (onMenu || ellipsisIcon) && this._menuRenderer()))), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        grow: true,
        shrink: true,
        className: tileClassName + "__body"
      }, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
        className: tileClassName + "__body__label",
        tooltipDelay: true,
        title: content.label,
        width: "100%",
        textDir: textDir,
        style: {
          maxWidth: '100%'
        },
        value: content.label
      }), /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        className: tileClassName + "__body__tag"
      }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
        orient: "right",
        title: content.type,
        delay: true
      }, /*#__PURE__*/_react["default"].createElement(_tags["default"], {
        tags: [{
          value: content.type,
          label: content.type,
          color: tagColor
        }],
        removable: false
      })))), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
        className: tileClassName + "__footer__date"
      }, dateLabel, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
        tooltipDelay: true,
        title: content.date,
        width: "100%",
        value: content.date
      })))));
    }

    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Tile, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], (0, _extends2["default"])({
      direction: "column"
    }, sanitize(others, Tile), {
      tabIndex: "0",
      onContextMenu: onMenu ? this._onContextMenu : null,
      className: classNames + " " + className
    }), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
      direction: "row",
      alignItems: "center",
      className: tileClassName + "__header"
    }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      className: tileClassName + "__icon__title",
      orient: "top",
      title: content.type,
      delay: true
    }, /*#__PURE__*/_react["default"].createElement(_svgicon["default"], {
      className: tileClassName + "__header__icon",
      iconId: content.iconId,
      title: content.type
    })), /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      tooltipDelay: true,
      title: content.type,
      width: "100%",
      value: content.type
    }))), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, {
      grow: true,
      shrink: true,
      className: tileClassName + "__body"
    }, /*#__PURE__*/_react["default"].createElement(_truncatedtext["default"], {
      tooltipDelay: true,
      title: content.label,
      width: "100%",
      textDir: textDir,
      value: content.label
    })), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, /*#__PURE__*/_react["default"].createElement(_flexlayout["default"], {
      alignItems: "center",
      justifyContent: "space-between",
      className: tileClassName + "__footer"
    }, /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
      className: tileClassName + "__date__title",
      orient: "bottom",
      title: content.date,
      delay: true
    }, /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, content.date)), /*#__PURE__*/_react["default"].createElement(_flexlayout.FlexItem, null, (onMenu || ellipsisIcon) && this._menuRenderer())))));
  };

  return Tile;
}(_react.Component);

exports["default"] = Tile;
(0, _defineProperty2["default"])(Tile, "propTypes", {
  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Select large or small size of the tile */
  size: _propTypes["default"].string,

  /** Determines if the tile is an asset or a container (folder) */
  container: _propTypes["default"].bool,

  /** Flag to select the tile */
  selected: _propTypes["default"].bool,

  /** Data passed to tile */
  content: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    iconId: _propTypes["default"].string,
    label: _propTypes["default"].string,
    date: _propTypes["default"].string,
    color: _propTypes["default"].string,
    value: _propTypes["default"].any
  }).isRequired,

  /** Callback function for context menu */
  onMenu: _propTypes["default"].func,

  /** Svg icon when loading context menu */
  ellipsisIcon: _propTypes["default"].element,
  ellipsisTooltipLabel: _propTypes["default"].string,
  dateLabel: _propTypes["default"].string,

  /** Text direction */
  textDir: _propTypes["default"].oneOf(['', 'ltr', 'rtl', 'auto'])
});
(0, _defineProperty2["default"])(Tile, "defaultProps", {
  size: 'small',
  container: false,
  selected: false,
  className: '',
  ellipsisTooltipLabel: 'Action menu',
  dateLabel: 'Last modified'
});

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-tile.is-small .ba-common-tile__body,.ba-common-tile.is-large .ba-common-tile__body__label,.ba-common-tile.is-container .ba-common-tile__middle__label{font-size:1rem;font-weight:400;line-height:1.25rem}.ba-common-tile.is-small .ba-common-tile__header,.ba-common-tile.is-small .ba-common-tile__footer,.ba-common-tile.is-large .ba-common-tile__header,.ba-common-tile.is-large .ba-common-tile__body__tag,.ba-common-tile.is-large .ba-common-tile__footer__date,.ba-common-tile.is-container .ba-common-tile__left,.ba-common-tile.is-container .ba-common-tile__middle__date,.ba-common-tile.is-container .ba-common-tile__right{font-size:.75rem;font-weight:400;line-height:1rem}.ba-common-tile *{cursor:pointer}.ba-common-tile{width:274px;padding:1px 16px;cursor:pointer}.ba-common-tile.is-selected{padding:0 15px;border-width:2px}.ba-common-tile .ba-common-tile__footer__icon:hover{color:#0f62fe}.ba-common-tile.is-small{background-color:#e0e0e0;height:140px}.ba-common-tile.is-small .ba-common-tile__header{height:48px;color:#161616}.ba-common-tile.is-small .ba-common-tile__header__icon{padding-right:8px}.ba-common-tile.is-small .ba-common-tile__body{color:#0f62fe}.ba-common-tile.is-small .ba-common-tile__footer{height:48px;color:#161616}.ba-common-tile.is-large{background-color:#e0e0e0;height:295px;width:295px;padding:8px 16px 16px 16px}.ba-common-tile.is-large .ba-common-tile__header{height:48px;color:#161616}.ba-common-tile.is-large .ba-common-tile__header__icon{transform:rotate(90deg)}.ba-common-tile.is-large .ba-common-tile__header svg.contextMenuButton{padding-top:0px !important;margin-right:-12px !important}.ba-common-tile.is-large .ba-common-tile__body{margin-top:12px;color:#161616}.ba-common-tile.is-large .ba-common-tile__body__label{font-size:24px;margin-bottom:8px;max-width:100%}.ba-common-tile.is-large .ba-common-tile__body__tag{height:16px;color:#161616}.ba-common-tile.is-large .ba-common-tile__footer{margin-top:12px;color:#161616}.ba-common-tile.is-large .ba-common-tile__footer__date{color:#161616}.ba-common-tile.is-large .ba-common-tags__listItem{padding:4px 8px !important;margin:16px 0px 0px 0px !important}[dir=\"rtl\"] .ba-common-tile__header__icon{padding-left:8px;padding-right:unset}[dir=\"rtl\"] .ba-common-tile__footer__icon{margin-right:16px;margin-left:unset}.ba-common-tile.is-container{background-color:#fff;height:64px}.ba-common-tile.is-container .ba-common-tile__left{color:#161616}.ba-common-tile.is-container .ba-common-tile__middle{color:#0f62fe}.ba-common-tile.is-container .ba-common-tile__middle__label{color:#0f62fe}.ba-common-tile.is-container .ba-common-tile__middle__date{color:#161616}.ba-common-tile.is-container .ba-common-tile__right{color:#161616}[dir=\"ltr\"] .ba-common-tile.is-container .ba-common-tile__middle,.ba-common-tile.is-container .ba-common-tile__middle{padding-left:16px}[dir=\"rtl\"] .ba-common-tile.is-container .ba-common-tile__middle{padding-right:16px;padding-left:unset}\n", ""]);

// exports
exports.locals = {
	"tileClassName": "\"ba-common-tile\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/folder_32");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[529,0]]]);
});